export interface IHppPayload {
    paymentIntentId: string;
    saveCard: boolean;
}

export const mapHppPayload = (paymentIntentId: string): IHppPayload => ({
    paymentIntentId,
    saveCard: true,
});
